import React from 'react';
import { View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import PropTypes from 'prop-types';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { Images } from '../../Themes';

import Scrubber from './Scrubber';
import Time from './Time';
import ToggleIcon from './ToggleIcon';
import styles from './Video.Styles';

const ControlBar = ({
  onSeek,
  onSeekRelease,
  progress,
  currentTime,
  duration,
  muted,
  paused,
  togglePlay,
  toggleMute,
}) => {
  return (
    <LinearGradient colors={[Colors.transparent, Colors.blackRGBA(0.4), Colors.blackRGBA(0.9)]}>
      <View style={styles.controlBarContainer}>
        <ToggleIcon
          onPress={togglePlay}
          isOn={paused}
          iconOff={Images.ic_play_arrow_white}
          iconOn={Images.ic_pause_white}
        />
        <Time time={currentTime} />
        <Scrubber onSeek={onSeek} onSeekRelease={onSeekRelease} progress={progress} />
        <Time time={duration} />
        <ToggleIcon
          onPress={toggleMute}
          isOn={muted}
          iconOff={Images.ic_sound_active_white}
          iconOn={Images.ic_sound_off}
        />
      </View>
    </LinearGradient>
  );
};

ControlBar.propTypes = {
  toggleMute: PropTypes.func.isRequired,
  onSeek: PropTypes.func.isRequired,
  onSeekRelease: PropTypes.func.isRequired,
  muted: PropTypes.bool.isRequired,
  progress: PropTypes.number.isRequired,
  currentTime: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  togglePlay: PropTypes.func,
  paused: PropTypes.bool,
};

export default ControlBar;
